import yall from 'yall-js';
import addClass from 'dom-helpers/addClass';
import hasClass from 'dom-helpers/hasClass';

export default doc => {
  yall({
    observeChanges: true,
    events: {
      load: e => {
        let $target = e.target;
        if (hasClass($target, 'imgl')) {
          addClass($target, 'imgl-in');
        }
      },
    },
  });
};
